import { render, staticRenderFns } from "./home.vue?vue&type=template&id=24fd0206&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/page_style/home.scss?vue&type=style&index=0&id=24fd0206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd0206",
  null
  
)

export default component.exports